export default "__VITE_ASSET__C_A1Q04X__"